/* ═══════════════════════════════════════════════════════════════════════
   MM-COUTURE.JS · Comportamiento de la cabecera
   ───────────────────────────────────────────────────────────────────────
   Solo se ocupa de abrir y cerrar: cajón de menú, segundo nivel y cortina
   de búsqueda, más la cabecera translúcida del inicio.

   ⚠️ REGLA INQUEBRANTABLE (ver P-003)
   Este archivo NUNCA escribe una variable CSS que afecte al tamaño de un
   elemento que después se mide. Eso provocó un bucle de crecimiento
   infinito. Aquí solo se leen medidas, jamás se escriben.

   El carrito y la búsqueda predictiva los maneja theme.js de Prestige.
   No los tocamos.
   ═══════════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var cuerpo = document.body;

  /* ─── Utilidades ─────────────────────────────────────────────────── */

  function bloquearScroll(bloquear) {
    cuerpo.style.overflow = bloquear ? 'hidden' : '';
  }

  /** Devuelve los elementos enfocables dentro de un contenedor. */
  function enfocables(raiz) {
    return raiz.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]),' +
      'select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
  }

  /** Mantiene el foco dentro del panel abierto (accesibilidad). */
  function atraparFoco(panel, evento) {
    if (evento.key !== 'Tab') return;
    var lista = enfocables(panel);
    if (!lista.length) return;

    var primero = lista[0];
    var ultimo = lista[lista.length - 1];

    if (evento.shiftKey && document.activeElement === primero) {
      evento.preventDefault();
      ultimo.focus();
    } else if (!evento.shiftKey && document.activeElement === ultimo) {
      evento.preventDefault();
      primero.focus();
    }
  }

  /* ─── Cajón del menú móvil ───────────────────────────────────────── */

  function iniciarMenu() {
    var cajon = document.getElementById('mm-cajon-menu');
    var velo = document.querySelector('[data-mm-velo-menu]');
    if (!cajon) return;

    var ultimoFoco = null;

    function abrir() {
      ultimoFoco = document.activeElement;
      cajon.setAttribute('data-abierto', 'true');
      cajon.setAttribute('aria-hidden', 'false');
      if (velo) {
        velo.hidden = false;
        // el siguiente cuadro, para que la transición se vea
        requestAnimationFrame(function () {
          velo.setAttribute('data-abierto', 'true');
        });
      }
      bloquearScroll(true);

      document.querySelectorAll('[data-mm-abrir-menu]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'true');
      });

      var primero = enfocables(cajon)[0];
      if (primero) setTimeout(function () { primero.focus(); }, 120);
    }

    function cerrar() {
      cajon.setAttribute('data-abierto', 'false');
      cajon.setAttribute('aria-hidden', 'true');
      if (velo) {
        velo.setAttribute('data-abierto', 'false');
        setTimeout(function () { velo.hidden = true; }, 400);
      }
      bloquearScroll(false);
      cerrarNiveles();

      document.querySelectorAll('[data-mm-abrir-menu]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });

      if (ultimoFoco) ultimoFoco.focus();
    }

    function cerrarNiveles() {
      cajon.querySelectorAll('.mm-nivel').forEach(function (n) {
        n.hidden = true;
        n.removeAttribute('data-abierto');
      });
      cajon.querySelectorAll('[data-mm-abrir-nivel]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-mm-abrir-menu]')) { e.preventDefault(); abrir(); return; }
      if (e.target.closest('[data-mm-cerrar-menu]')) { e.preventDefault(); cerrar(); return; }
      if (velo && e.target === velo) { cerrar(); return; }

      /* Segundo nivel */
      var abrirNivel = e.target.closest('[data-mm-abrir-nivel]');
      if (abrirNivel) {
        e.preventDefault();
        var nivel = document.getElementById(abrirNivel.dataset.mmAbrirNivel);
        if (nivel) {
          nivel.hidden = false;
          requestAnimationFrame(function () {
            nivel.setAttribute('data-abierto', 'true');
          });
          abrirNivel.setAttribute('aria-expanded', 'true');
          var p = enfocables(nivel)[0];
          if (p) setTimeout(function () { p.focus(); }, 120);
        }
        return;
      }

      if (e.target.closest('[data-mm-cerrar-nivel]')) {
        e.preventDefault();
        cerrarNiveles();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (cajon.getAttribute('data-abierto') !== 'true') return;
      if (e.key === 'Escape') { cerrar(); return; }
      atraparFoco(cajon, e);
    });
  }

  /* ─── Cortina de búsqueda ────────────────────────────────────────────
     Prestige ya gestiona <header-search> con su propio componente.
     Aquí solo añadimos el bloqueo de scroll y el cierre con Escape,
     sin interferir con su lógica.
  ─────────────────────────────────────────────────────────────────── */

  function iniciarBusqueda() {
    var cortina = document.querySelector('[data-mm-cortina]');
    if (!cortina) return;

    function abrir() {
      cortina.setAttribute('data-abierta', 'true');   /* lo que lee el CSS */
      cortina.setAttribute('open', '');
      cortina.setAttribute('aria-hidden', 'false');
      bloquearScroll(true);
      /* El foco al campo, pero tras la transición: enfocar un elemento
         aún invisible no funciona en Safari. */
      var campo = cortina.querySelector('input[type="search"], input[name="q"]');
      if (campo) setTimeout(function () { campo.focus(); }, 60);
    }

    function cerrar() {
      cortina.removeAttribute('data-abierta');
      cortina.removeAttribute('open');
      cortina.removeAttribute('data-escribiendo');
      cortina.setAttribute('aria-hidden', 'true');
      bloquearScroll(false);
    }

    /* Delegación: el botón puede venir de la cabecera de escritorio o de
       la móvil, y ambas se repintan al editar la sección. */
    document.addEventListener('click', function (e) {
      var disparador = e.target.closest('[data-mm-abrir-busqueda], [aria-controls="mm-busqueda"]');
      if (disparador) {
        e.preventDefault();   /* si es un <a href="/search">, no navegar */
        abrir();
        return;
      }
      if (e.target.closest('[data-mm-cerrar-busqueda]')) { cerrar(); return; }
      /* Clic fuera del contenido: cerrar */
      if (cortina.hasAttribute('data-abierta') && e.target === cortina) cerrar();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && cortina.hasAttribute('data-abierta')) cerrar();
    });

    /* Atrapar el foco dentro de la cortina mientras está abierta */
    cortina.addEventListener('keydown', function (e) {
      if (e.key === 'Tab' && cortina.hasAttribute('data-abierta')) atraparFoco(cortina, e);
    });

    /* Al escribir se cambia la vista: los atajos dejan sitio a los
       resultados. El CSS lo controla con [data-escribiendo]. */
    var campo = cortina.querySelector('input[type="search"], input[name="q"]');
    if (campo) {
      campo.addEventListener('input', function () {
        if (campo.value.trim().length > 0) {
          cortina.setAttribute('data-escribiendo', 'true');
        } else {
          cortina.removeAttribute('data-escribiendo');
        }
      });
    }
  }

  /* ─── Cabecera translúcida del inicio ────────────────────────────── */

  function iniciarCabeceraFlotante() {
    var envoltorio = document.querySelector('.mm-cabecera-flotante');
    if (!envoltorio) return;

    var cabecera = envoltorio.querySelector('.mm-cabecera');
    var portada = document.querySelector('.mm-hero');
    if (!cabecera || !portada) return;

    /* Solo LEEMOS el alto; nunca lo escribimos como variable CSS. */
    var alto = cabecera.offsetHeight || 112;

    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(
        function (entradas) {
          entradas.forEach(function (entrada) {
            cabecera.setAttribute('data-solida', String(!entrada.isIntersecting));
          });
        },
        { rootMargin: '-' + alto + 'px 0px 0px 0px', threshold: 0 }
      );
      obs.observe(portada);
      return;
    }

    /* Respaldo por scroll */
    function alDesplazar() {
      var limite = portada.offsetHeight - alto;
      cabecera.setAttribute('data-solida', String(window.scrollY > limite));
    }
    window.addEventListener('scroll', alDesplazar, { passive: true });
    alDesplazar();
  }


  /* ─── Cajón de filtros (colección en móvil) ──────────────────────── */

  function iniciarFiltros() {
    var cajon = document.getElementById('mm-cajon-filtros');
    var velo = document.querySelector('[data-mm-velo-filtros]');
    if (!cajon) return;

    var ultimoFoco = null;

    function abrir() {
      ultimoFoco = document.activeElement;
      cajon.setAttribute('data-abierto', 'true');
      cajon.setAttribute('aria-hidden', 'false');
      if (velo) {
        velo.hidden = false;
        requestAnimationFrame(function () { velo.setAttribute('data-abierto', 'true'); });
      }
      bloquearScroll(true);

      document.querySelectorAll('[data-mm-abrir-filtros]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'true');
      });

      var primero = enfocables(cajon)[0];
      if (primero) setTimeout(function () { primero.focus(); }, 120);
    }

    function cerrar() {
      cajon.setAttribute('data-abierto', 'false');
      cajon.setAttribute('aria-hidden', 'true');
      if (velo) {
        velo.setAttribute('data-abierto', 'false');
        setTimeout(function () { velo.hidden = true; }, 400);
      }
      bloquearScroll(false);

      document.querySelectorAll('[data-mm-abrir-filtros]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });

      if (ultimoFoco) ultimoFoco.focus();
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-mm-abrir-filtros]')) { e.preventDefault(); abrir(); return; }
      if (e.target.closest('[data-mm-cerrar-filtros]')) { e.preventDefault(); cerrar(); return; }
      if (velo && e.target === velo) cerrar();
    });

    document.addEventListener('keydown', function (e) {
      if (cajon.getAttribute('data-abierto') !== 'true') return;
      if (e.key === 'Escape') { cerrar(); return; }
      atraparFoco(cajon, e);
    });
  }

  /* ─── Selector de orden ──────────────────────────────────────────────
     Recarga con el parámetro sort_by. Es un <select> normal, así que sin
     JavaScript basta con enviarlo desde el formulario de filtros.
  ─────────────────────────────────────────────────────────────────── */

  function iniciarOrden() {
    document.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-mm-orden]');
      if (!sel) return;

      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }


  /* ─── Galería de producto ────────────────────────────────────────── */

  /* ─── Galería de producto ────────────────────────────────────────
     El deslizamiento lo hace el CSS (scroll-snap). Aquí solo:
       · al pulsar una miniatura, llevar la pista a esa imagen
       · al deslizar, marcar la miniatura que corresponde

     Nunca se escribe una medida: el observador solo lee. Ver P-003.
  ─────────────────────────────────────────────────────────────── */

  function iniciarGaleria() {
    var galeria = document.querySelector('[data-mm-galeria]');
    if (!galeria) return;

    var pista = galeria.querySelector('[data-mm-pista]');
    if (!pista) return;

    var minis  = Array.prototype.slice.call(galeria.querySelectorAll('[data-mm-ir]'));
    var diapos = Array.prototype.slice.call(galeria.querySelectorAll('[data-mm-diapo]'));
    function marcar(indice) {
      minis.forEach(function (m) {
        m.setAttribute('aria-current', String(Number(m.dataset.mmIr) === indice));
      });
    }

    /* Pulsar una miniatura desplaza la pista */
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var destino = diapos[Number(mini.dataset.mmIr)];
        if (!destino) return;
        pista.scrollTo({
          left: destino.offsetLeft - pista.offsetLeft,
          behavior: 'smooth'
        });
      });
    });

    /* Al deslizar, marcar la que se esté viendo.
       IntersectionObserver es más barato que escuchar el scroll. */
    if ('IntersectionObserver' in window) {
      var observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (entrada) {
          if (entrada.isIntersecting && entrada.intersectionRatio > 0.55) {
            marcar(Number(entrada.target.dataset.mmDiapo));
          }
        });
      }, { root: pista, threshold: [0.55] });

      diapos.forEach(function (d) { observador.observe(d); });
    }
  }


  /* --- Insignia del carrito ------------------------------------------
     theme.js de Prestige actualiza el contenido de <cart-count> al
     cambiar el carrito, pero no sabe nada de nuestra insignia. Aqui la
     mostramos u ocultamos segun el numero.

     Observamos el TEXTO de cart-count, no su tamano, asi que no hay
     riesgo del bucle de P-003.
  ------------------------------------------------------------------- */

  function iniciarInsigniaCarrito() {
    var contador = document.querySelector('.mm-cabecera cart-count');
    if (!contador) return;

    var insignia = contador.closest('.mm-icono-boton__conteo');
    if (!insignia) return;

    function refrescar() {
      var n = parseInt((contador.textContent || '0').trim(), 10);
      if (isNaN(n) || n <= 0) {
        insignia.classList.add('mm-oculto');
      } else {
        insignia.classList.remove('mm-oculto');
      }
    }

    refrescar();

    var observador = new MutationObserver(refrescar);
    observador.observe(contador, { childList: true, characterData: true, subtree: true });

    /* Prestige emite estos eventos al cambiar el carrito */
    ['cart:change', 'cart:refresh', 'variant:add'].forEach(function (evento) {
      document.addEventListener(evento, function () {
        setTimeout(refrescar, 60);
      });
    });
  }

  /* ─── Acordeones (filtros, detalles de producto) ─────────────────── */

  function iniciarAcordeones() {
    document.addEventListener('click', function (e) {
      var cabeza = e.target.closest('[data-mm-acordeon]');
      if (!cabeza) return;

      e.preventDefault();
      var grupo = cabeza.closest('.mm-grupo, .mm-detalle');
      if (!grupo) return;

      var abierto = grupo.getAttribute('data-abierto') === 'true';
      grupo.setAttribute('data-abierto', String(!abierto));
      cabeza.setAttribute('aria-expanded', String(!abierto));
    });
  }

  /* ─── Arranque ───────────────────────────────────────────────────── */

  function iniciar() {
    iniciarMenu();
    iniciarBusqueda();
    iniciarCabeceraFlotante();
    iniciarFiltros();
    iniciarOrden();
    iniciarGaleria();
    iniciarInsigniaCarrito();
    iniciarAcordeones();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  /* El editor de temas recarga secciones sin refrescar la página */
  document.addEventListener('shopify:section:load', iniciar);
})();
